import { H2, Section } from "./common-components";
import { GetAllReferrals } from "../common/GetAllReferrals";
import { NotificationOfService } from "./NotificationOfService";
import { AlertConfirmationTypes } from "../../../helpers/constant";

export const ReferralAlertInformation = ({confirmationType = null, documentation, formType}) => {
   
  return (
    <>
      <Section>
        <H2>Referral Information</H2>
        <div className="space-y-3">
          <GetAllReferrals confirmationType={confirmationType} documentation={documentation} />
        </div>
      </Section>

      {documentation && (
        <NotificationOfService documentation={documentation} formType={formType} alertConfirmationType={AlertConfirmationTypes.NotificationOfService} />
      )}
    </>
  );
};
